<template>
    <footer :class="['footer-wrap', { 'footer-wrap--mobile': !isPc }]">
        <div class="footer-container">
            <!-- 左侧 Logo + 文案 -->
            <div class="footer-left">
                <img src="https://file.zmxs.com.cn/img/newLogo2026-09-02140102.png" alt="智面玄赏" class="footer-logo" />
                <p class="footer-slogan">精准找人 · 批量招人 · 就上智面玄赏</p>
                <p class="footer-desc">数智化分润式招聘平台：AI面试提效，悬赏按结果付费。</p>
                <p v-if="isPc" class="footer-desc">联系邮箱：zmxs@msxzs.com</p>
            </div>

            <!-- 中间双栏导航菜单 -->
            <div class="footer-nav">
                <div class="footer-column">
                    <div class="menu-title">进入产品</div>
                    <div class="menu-item" v-for="item in productList" :key="item.path" @click="topath(item.path)">
                        {{ item.title }}</div>
                </div>
                <div class="footer-column">
                    <div class="menu-title">了解更多</div>
                    <div class="menu-item" v-for="item in productList_1" :key="item.path" @click="topath(item.path)">
                        {{ item.title }}</div>
                </div>
                <div class="footer-column">
                    <div class="menu-title">服务与支持</div>
                    <div class="menu-item" v-for="item in productList_2" :key="item.path" @click="topath(item.path)">
                        {{ item.title }}</div>
                </div>
            </div>
        </div>

        <!-- 分割线 + 底部版权行（左右分栏） -->
        <div class="footer-bottom">
            <div class="footer-bottom-left">
                <span class="copyright">© 2026 智面玄赏</span>
            </div>
            <div class="footer-bottom-right">
                <p>公司地址：成都市武侯区天府大道中段688号大源国际中心3栋2001</p>
                <p><img src="https://file.zmxs.com.cn/img/2026-09-02140103.png" alt="" srcset=""
                        class="w-20 inline-block  ">
                    <a href="https://beian.miit.gov.cn/" target="_blank"> 浙ICP备2025216198号</a>
                </p>
            </div>
        </div>
        <el-dialog class="mtDialog" :visible.sync="dialogVisible" width="600px" :show-close="false">
            <div class="flex items-center pt-30 justify-between">
                <div class="text-[16px]  text-[#000000] font-semibold ">联系我们</div>
                <img src="https://file.zmxs.com.cn/img/2026-09-02140104.png" alt="" class="w-20 h-20 "
                    @click="dialogVisible = false">
            </div>
            <div class="flex justify-between pb-20 mt-30">
                <div class="flex justify-between w-full">
                    <div class="bg-[#F4FCFF] pt-17 pl-21 pb-23 pr-100 rounded-[10px]">
                        <img src="https://file.zmxs.com.cn/img/2026-09-02140105.png" alt="" class="w-25 h-25">
                        <div class="mt-13 text-[#222222] text-[14px] font-semibold">合作咨询电话</div>
                        <div class="mt-13 text-[#666666] text-[18px] font-normal">19934456121</div>
                    </div>
                    <div class="bg-[#F4FCFF] pt-17 pl-21 pb-23 pr-20  rounded-[10px] flex ">
                        <div>
                            <img src="https://file.zmxs.com.cn/img/2026-09-02140106.png" alt="" class="w-25 h-25">
                            <div class="mt-13 text-[#222222] text-[14px] font-semibold">添加企业微信顾问</div>
                            <div class="mt-13 text-[#666666] text-[18px] font-normal">为您详细解答</div>
                        </div>
                        <img src="https://file.zmxs.com.cn/img/2026-09-02140107.png" alt="" class="w-95 h-95 ml-20 ">
                    </div>
                </div>
            </div>
            <div class="bg-[#F4FCFF] pt-20 pl-21 pb-23 pr-20  rounded-[10px]  ">
                <div>
                    <img src="https://file.zmxs.com.cn/img/2026-09-02140106.png" alt="" class="w-25 h-25">
                    <div class="mt-13 text-[#222222] text-[14px] font-semibold">联系地址</div>
                    <div class="mt-13 text-[#666666] text-[18px] font-normal">成都市武侯区天府大道中段688号大源国际中心3栋2001</div>
                </div>
            </div>

        </el-dialog>
    </footer>
</template>

<script>
import { resolveHref } from "@/multi/pageRoutes";
import { determineDeviceType } from "@/plugins/untils.js";

export default {
    name: "PageFooter",
    data() {
        return {
            isPc: true,
            resizeHandler: null,
            dialogVisible: false,
            productList: [
                { path: 'bountyRecruitment', title: '悬赏招聘' },
                { path: 'talent', title: 'InterviewAI·AI 面试' },
                { path: 'interview', title: 'TalentHub·人才管理' },
                { path: 'employment', title: 'JobCabin·就业舱' },
                { path: 'offerBot', title: 'OfferBot·求职助理' },
            ],
            productList_1: [
                { path: 'cooperation', title: '对外合作' },
                { path: 'news', title: '新闻中心' },
                { path: 'about-us', title: '关于我们' },
            ],
            productList_2: [
                { path: 'about-us#contact', title: '预约演示' },
                { path: 'https://job.zmxs.com.cn', title: '企业端登录' },
            ]
        }
    },
    mounted() {
        this.resizeHandler = () => {
            this.isPc = determineDeviceType();
        };
        this.resizeHandler();
        window.addEventListener('resize', this.resizeHandler);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeHandler);
    },
    methods: {
        topath(name) {
            if (name.indexOf('https') !== -1) {
                if (determineDeviceType()) {
                    window.open(name, '_blank')
                } else {
                    window.open(window.jumpBUrl)
                }
                return
            }

            const [routeName, hash = ''] = name.split('#')
            const href = resolveHref({
                name: routeName,
                hash,
            });

            window.location.assign(href);
        }
    }
}
</script>

<style scoped lang="less">
.mtDialog {
    border-radius: 20px;

    ::v-deep.el-dialog {
        border-radius: 10px;
    }

    ::v-deep.el-dialog__header {
        padding: 0px 20px !important;
    }

    ::v-deep.el-dialog__body {
        padding: 0px 20px 20px 20px !important;
    }

}

.footer-wrap {
    background-color: #0b0c1c;
    padding: 60px 40px 30px;
    color: #c2c6e0;
    font-size: 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-container {
    max-width: 1400px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    gap: 60px;
}

.footer-left {
    flex-shrink: 0;
    font-size: 14px;

    .footer-logo {
        height: 33px;
        margin-bottom: 20px;
    }

    .footer-slogan {
        font-weight: 400;
        font-size: 14px;
        line-height: 19px;
        color: #6E7494;
        margin: 8px 0;
    }

    .footer-desc {
        font-weight: 400;
        font-size: 14px;
        line-height: 19px;
        margin-bottom: 7px;
        color: #6E7494;
    }
}

.footer-nav {
    display: flex;
    gap: 80px;
    flex-shrink: 0;
}

.footer-column {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .menu-title {
        font-size: 14px;
        color: #6E7494;
        line-height: 17px;
        margin-bottom: 15px;
    }

    .menu-item {
        cursor: pointer;
        transition: color 0.2s;
        font-weight: 400;
        font-size: 14px;
        color: #A2A8C6;
        line-height: 20px;

        &:hover {
            color: #ffffff;
        }
    }
}

// 二维码容器
.footer-qrcode {
    display: flex;
    gap: 24px;
    flex-shrink: 0;

    .qr-item {
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
            width: 88px;
            height: 88px;
            margin-bottom: 10px;
            border-radius: 20px;
        }

        p {
            font-size: 13px;
            color: #6E7494;
            text-align: center;
            line-height: 18px;
        }
    }
}

.footer-bottom {
    max-width: 1400px;
    margin: 50px auto 0;
    padding-top: 24px;
    border-top: 1px solid #202238;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #6E7494;
    line-height: 22px;

    .footer-bottom-left {
        font-size: 14px;
        display: flex;
        flex-direction: column;
        gap: 6px;
    }
}

.footer-bottom-right {
    font-size: 14px;

    p {
        margin-bottom: 10px;
    }
}

.footer-wrap--mobile {
    padding: 67px 48px;
    background: #0A0C1E;
    border-top: none;

    .footer-container {
        max-width: none;
        display: block;
    }

    .footer-left {
        text-align: center;

        .footer-logo {
            height: 63px;
            width: 244px;
            margin: 0 auto 28px;
        }

        .footer-slogan {
            font-size: 26px;
            color: #6E7494;
            margin-bottom: 20px;
        }

        .footer-desc {
            font-size: 26px;
            color: #6E7494;
            margin: 0;
        }
    }

    .footer-nav {
        display: block;
        margin-top: 88px;
    }

    .footer-column {
        gap: 0;

        &+& {
            margin-top: 26px;
        }

        .menu-title {
            margin-bottom: 36px;
            margin-top: 40px;
            font-size: 24px;
            color: #6E7494;
        }

        .menu-item {
            display: flex;
            align-items: center;
            padding: 10px 10px 26px 10px;
            font-size: 24px;
            line-height: 1.5;
            color: #A2A8C6;
            border-bottom: 1px solid rgba(123, 133, 176, 0.18);
        }
    }

    .footer-bottom {
        max-width: none;
        margin-top: 28px;
        padding-top: 24px;
        border-top: 1px solid rgba(123, 133, 176, 0.18);
        display: block;
        line-height: 1.7;

        .footer-bottom-left {
            font-size: 24px;
            color: #6E7494;
        }
    }

    .footer-bottom-right {
        margin-top: 16px;
        font-size: 24px;
        color: #6E7494;

        p {
            margin-bottom: 10px;
        }

        a {
            color: inherit;
        }
    }
}
</style>
